export const getUrlSearch = (name) => {
  const params = new URLSearchParams(document.location.search.substring(1));
  return params.get(name);
};
